import RadioButton from "@frameworks/web/components/generic/radioButton";
import NotificationMessage from "@frameworks/web/components/features/TOC/CommonTocComponent/StatusMessage/NotificationMessage";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { DiffBankAccountDesc } from "../../NFOConstant";
import BankAccount from "../CommonPaymentMethod/BankAccount";
const DiffrentBankAccountData = (props) => {
    var _a;
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: "notificationsection ps-md-56" },
                React.createElement(NotificationMessage, { borderColor: "#FEF4EC", backColor: "#FEF4EC", prefredIcon: true, notiHeading: "Preferred Banks", DescriptionTop: DiffBankAccountDesc, ShowlinkValue: false, showDescriptionBottom: false, parentclass: "noti-small-section" })),
            React.createElement(Col, { lg: 12, className: "BankAccountSectionOuter" }, (_a = props.bankList) === null || _a === void 0 ? void 0 : _a.map((item) => {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "BankAccountSection" },
                        React.createElement(RadioButton, { className: "common-radio-button paymentmethodradio", name: "bankAccount", list: { display: "", value: item.bnkAcNo }, selected: props.selectedAccount, onChange: () => {
                                props.setSelectedAccount(item.bnkAcNo);
                            } }),
                        React.createElement(BankAccount, { sectionHeadleftTop: "Bank Account Number", sectionHeadleftBottom: item.bnkAcNo, sectionHeadRightTop: "Bank Name", sectionHeadRightBottom: item.bnkNm, hideIcon: !item.def }))));
            })))));
};
export default DiffrentBankAccountData;
